import axios from "axios";
import { getSubdomain, handleSessionExpiry } from "./apiClient";

const reportBuilderAPIClientFactory = () => {
	const domain =
		sessionStorage.getItem("DomainDetails") !== null
			? sessionStorage.getItem("DomainDetails")
			: "";
	// const domain =
	// 	localStorage.getItem("DomainDetails") !== null
	// 		? localStorage.getItem("DomainDetails")
	// 		: "";
	const apiClient = axios.create({
		baseURL: process.env.REACT_APP_REPORT_BUILDER_API_URL,
		timeout: 50000,
		headers: {
			Authorization: `Bearer ${
				localStorage.getItem("userToken") || "no token"
			}`,
			domain: domain,
		},
	});

	apiClient.interceptors.response.use(
		(response) => response,
		(err) => {
			handleSessionExpiry(err);
			return Promise.reject(err);
		},
	);

	console.log("SUB DOMAIN", getSubdomain());
	return apiClient;
};

export default reportBuilderAPIClientFactory;
